// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14d8L","col":"styles_col__3GS8D"};